export default "__VITE_ASSET__CHqz2u54__"